import { Pipe, PipeTransform } from '@angular/core';
import { CheckResultSeverity, CheckType } from '@app/core/model/entities/asset/check-type';

@Pipe({
    name: 'checkResultColour',
    standalone: false
})
export class CheckResultColourPipe implements PipeTransform {

  /**
   * Resolve the CSS class rendering the severity of a Check result value, as declared by the CheckType.
   * @param input Value of the result field.
   * @param args CheckType the Check belongs to, and code of the result field holding the value.
   * @return The severity CSS class, or undefined when the value has no declared severity.
   */
  public transform(input: string, args: { checkType: CheckType; fieldCode: string }): string {
    const severity = args?.checkType?.resultFields
      ?.find(resultField => resultField.fieldCode === args.fieldCode)?.values
      ?.find(resultValue => resultValue.value === input)?.severity;

    switch (severity) {
      case CheckResultSeverity.NONE:
        return 'result-type-none';
      case CheckResultSeverity.INFO:
        return 'result-type-info';
      case CheckResultSeverity.WARN:
        return 'result-type-warning';
      case CheckResultSeverity.ERROR:
        return 'result-type-danger';
      default:
        return undefined;
    }
  }
}
